<template>
    <div class="w-100 lm-border pa-3" style="height: 200px;">
        <v-row class="no-frame">
            <c-site-tzb-title
                :title         = "$t('unit.escalator.tzb.maintenance')"
                :rating        = "data.rating"
                :padding-right = "0"
            />
        </v-row>
        <v-row class="no-frame">
            <f-read-only-field
                :value = "data.company && data.company.name ? data.company.name : '-/-'"
                :label = "$t('unit.escalator.tzb.company')"
                class  = "w-100"
                :line  = "false"
                dense
            />
        </v-row>
        <v-row class="no-frame">
            <c-site-tzb-escalator-note
                :data     = "data"
                :editable = "editable"
                :rows     = "3"
            />
        </v-row>
    </div>
</template>

<script>
import CSiteTzbTitle         from "@/modules/msd/unit/components/dialog/CSiteTzbTitle";
import FReadOnlyField        from "@/modules/core/components/utils/FReadOnlyField";
import CSiteTzbEscalatorNote from "@/modules/msd/unit/components/dialog/CSiteTzbEscalatorNote";

/**
 * Maintenance quality of the escalator TZB (HCIT-937): rating, maintenance company of the app (read only) and the
 * LM4-only note.
 */
export default {
    name: "CSiteTzbEscalatorMaintenance",

    components: {
        CSiteTzbEscalatorNote,
        FReadOnlyField,
        CSiteTzbTitle,
    },

    props: {
        data: {
            required: true,
            type    : Object
        },

        editable: {
            type   : Boolean,
            default: false
        }
    },
}
</script>
